import './App.css';
import Landing from './components/Landing';
import NotFound from './components/NotFound';
import ComingSoon from './components/ComingSoon';
import ItProjects from './components/ItProjects';
import DevProjects from './components/DevProjects';
import Certifications from './components/Certifications';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Analytics } from "@vercel/analytics/react"


import {
  createBrowserRouter,
  RouterProvider
} from "react-router-dom";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Landing />,
    },
    
    {
      path: "/Products",
      element: <ComingSoon />,
    },
    {
      path: "/ItProjects",
      element: <ItProjects />,
    }
    ,
    {
      path: "/DevProjects",
      element: <DevProjects />,
    }
    ,
    {
      path: "/Certifications",
      element: <Certifications />,
    }
    ,
    {
      path: "*",
      element: <NotFound />,
    }
  ]);

  return (
    <div className="App">
      <RouterProvider router={router} />
      <Analytics />
      
    </div>
  );
}

export default App;
